<template>
  <v-app id="inspire">
    <!-- App Bar -->
    <v-app-bar :elevation="2" color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>MARC ESCUELA DE MANEJO</v-app-bar-title>
      <v-spacer></v-spacer>

      <!-- Cambiar tema -->
      <v-icon class="mx-2" @click="toggleTheme" icon="mdi-theme-light-dark"></v-icon>

      <!-- Notificación: Programaciones sin asistencia -->
      <v-menu :close-on-content-click="false" location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-badge :content="notifSinAsistencia.length" :model-value="notifSinAsistencia.length > 0" color="orange">
              <v-icon>mdi-account-clock</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card width="450" max-height="400" class="overflow-y-auto">
          <v-card-title class="text-subtitle-1 d-flex align-center ga-2">
            <v-icon color="orange" size="small">mdi-account-clock</v-icon>
            Programaciones sin asistencia
          </v-card-title>
          <v-divider />
          <v-list v-if="notifSinAsistencia.length" density="compact">
            <v-list-item v-for="(item, i) in notifSinAsistencia" :key="i" class="notif-item">
              <v-list-item-title class="text-body-2 font-weight-medium text-wrap">{{ item.alumno }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption text-wrap">
                {{ item.curso }}<br>
                {{ item.programaciones_pendientes.length }} clase(s) pendiente(s)
              </v-list-item-subtitle>
              <template v-slot:prepend>
                <v-icon color="orange" size="small">mdi-account</v-icon>
              </template>
            </v-list-item>
          </v-list>
          <v-card-text v-else>
            <v-alert type="success" variant="tonal" density="compact">No hay pendientes.</v-alert>
          </v-card-text>
        </v-card>
      </v-menu>

      <!-- Notificación: Alumnos que deben pagar -->
      <v-menu :close-on-content-click="false" location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-badge :content="notifDebePagar.length" :model-value="notifDebePagar.length > 0" color="blue">
              <v-icon>mdi-alert-circle-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card width="480" max-height="400" class="overflow-y-auto">
          <v-card-title class="text-subtitle-1 d-flex align-center ga-2">
            <v-icon color="blue" size="small">mdi-alert-circle-outline</v-icon>
            Deben pagar antes de siguiente clase
          </v-card-title>
          <v-divider />
          <v-list v-if="notifDebePagar.length" density="compact">
            <v-list-item v-for="(item, i) in notifDebePagar" :key="i" class="notif-item">
              <v-list-item-title class="text-body-2 font-weight-medium text-wrap">{{ item.alumno }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption text-wrap">
                {{ item.curso }}<br>
                Clases: {{ item.clases_realizadas }}/{{ item.clases_cubiertas }} — <span class="text-red font-weight-bold">Debe: S/ {{ Number(item.debe).toFixed(2) }}</span><br>
                Sig. clase: {{ item.siguiente_clase ? new Date(item.siguiente_clase).toLocaleString('es-PE', { dateStyle: 'short', timeStyle: 'short' }) : 'Sin programar' }}
              </v-list-item-subtitle>
              <template v-slot:prepend>
                <v-icon color="blue" size="small">mdi-account</v-icon>
              </template>
            </v-list-item>
          </v-list>
          <v-card-text v-else>
            <v-alert type="success" variant="tonal" density="compact">No hay pendientes.</v-alert>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-app-bar>

    <!-- Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" width="300">
      <v-list>
        <!-- Usuario con iniciales -->
        <v-list-item :title="user?.name">
          <template v-slot:subtitle>
            <span class="text-caption text-grey-lighten-1">{{ user?.email }}</span>
          </template>
          <template v-slot:prepend>
            <v-avatar color="primary" size="48">
              <span class="white--text font-weight-bold text-subtitle2">{{ userInitials }}</span>
            </v-avatar>
          </template>
        </v-list-item>

      </v-list>

      <v-divider></v-divider>

      <!-- Menú dinámico -->
      <v-list density="compact" nav>
        <template v-for="seccion in menuVisible" :key="seccion.titulo">
          <v-list-subheader>{{ seccion.titulo }}</v-list-subheader>
          <v-list-item v-for="item in seccion.items" :key="item.to" :to="item.to">
            <template v-slot:prepend>
              <v-icon :icon="item.icono"></v-icon>
            </template>
            <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            <template v-if="item.badge && $data[item.badge]" v-slot:append>
              <v-badge :content="$data[item.badge]" color="orange" inline></v-badge>
            </template>
          </v-list-item>
        </template>
      </v-list>

      <!-- Logout -->
      <v-btn size="small" block variant="tonal" @click="logout">
        Salir
      </v-btn>
    </v-navigation-drawer>

    <!-- Main content -->
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script setup>
import { useTheme } from 'vuetify';
const theme = useTheme();

// Tema desde localStorage
theme.global.name.value = localStorage.getItem('theme') || theme.global.name.value;

function toggleTheme() {
  theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark';
  localStorage.setItem('theme', theme.global.name.value);
}
</script>

<script>
import axios from 'axios';
import { MENU, puedeVerItem } from '@/menu';

export default {
  data() {
    return {
      drawer: null,
      notifSinAsistencia: [],
      notifDebePagar: [],
      solicitudesPendientes: 0,
    };
  },
  computed: {
    menuVisible() {
      const permisos = this.user?.permisos;
      return MENU
        .map(seccion => ({ ...seccion, items: seccion.items.filter(item => puedeVerItem(permisos, item)) }))
        .filter(seccion => seccion.items.length);
    },
    user() {
      return this.$store.state.user;
    },
    userInitials() {
      if (!this.user?.name) return '';
      return this.user.name
        .split(' ')
        .map(part => part.charAt(0).toUpperCase())
        .join('')
        .slice(0, 2);
    },
  },
  mounted() {
    this.cargarNotificaciones();
    this.cargarSolicitudesPendientes();
  },
  watch: {
    '$route'() {
      this.cargarSolicitudesPendientes();
    },
  },
  methods: {
    async cargarNotificaciones() {
      try {
        const [sinAsistencia, debePagar] = await Promise.all([
          axios.get('/api/notificaciones/programaciones-sin-asistencia'),
          axios.get('/api/notificaciones/alumnos-debe-pagar-clase'),
        ]);
        this.notifSinAsistencia = sinAsistencia.data;
        this.notifDebePagar = debePagar.data.sort((a, b) => {
          if (!a.siguiente_clase && !b.siguiente_clase) return 0;
          if (!a.siguiente_clase) return 1;
          if (!b.siguiente_clase) return -1;
          return new Date(a.siguiente_clase) - new Date(b.siguiente_clase);
        });
      } catch (e) {
        console.error('Error cargando notificaciones', e);
      }
    },
    async cargarSolicitudesPendientes() {
      if (!this.$store.getters.can('solicitudes-gasto.aprobar')) return;
      try {
        const { data } = await axios.get('/api/solicitud-gasto/pendientes');
        this.solicitudesPendientes = data.cantidad;
      } catch (e) {
        console.error('Error cargando solicitudes pendientes', e);
      }
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.notif-item :deep(.v-list-item-subtitle) {
  -webkit-line-clamp: unset !important;
  white-space: normal !important;
}
</style>
